<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br />
                        <a href="/card" class="link" style="text-decoration:none;">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <b>好みのカード</b>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container" style="padding-top:70px;">
                <br>
                <div class="row">
                    <div class="col">
                        <div class="table-responsive">
                            <table class="table table-borderless p-0">
                                <tbody class="p-0">
                                    <tr class="p-0">
                                        <td class="p-0">
                                            <div class="row flex-nowrap" style="padding:0 10px;">
                                                <div class="col-4 px-0" style="margin:0 5px;" v-for="category in categorys"
                                                    :key="category.id">
                                                    <a :href="'/card/category/list?type=' + category.id"
                                                        style="color:#000;">
                                                        <div class="category-box text-center" style="width:100%;"
                                                            v-if="category.thumbnail_image == null">
                                                            {{ category.name }}
                                                        </div>
                                                        <div :style="'background: url(' + category.thumbnail_image + ') center center no-repeat;' +
                                                            'background-size: cover;' +
                                                            'width:100%;' +
                                                            'color: #fff;' +
                                                            'border-radius: 8px;'
                                                            " v-else>
                                                            <div class="category-box-filter text-center"
                                                                style="width:100%;">
                                                                {{ category.name }}
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col px-0" style="padding-top:20px;">
                        <div class="category-header text-center" style="width:100%;"
                            v-if="category.thumbnail_image == null">
                            {{ category.name }}
                        </div>
                        <div :style="'background: url(' + category.thumbnail_image + ') center center no-repeat;' +
                            'background-size: cover;' +
                            'width:100%;' +
                            'color: #fff;' +
                            'border-radius: 8px;'
                            " v-else>
                            <div class="category-header-filter text-center" style="width:100%;">
                                {{ category.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 px-0" v-for="card in cards" :key="card.id">
                        <a :href="'/card/detail/' + card.id">
                            <div style="margin:8px;">
                                <img :src="card.thumbnail_image" class="luna-rounded img-fluid">
                                <div><small>{{ card.name }}</small></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row" v-if="count != 0">
                    <div class="col">
                        <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                            v-if="is_page && count != 0">
                            <a @click="fetchCategoryMore()">もっとみる</a>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="is_load_under">
                    <div class="col text-center">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <FooterMenu currentPage="card" />
    </div>
</template>

<script>
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        FooterMenu,
    },
    data() {
        return {
            categorys: [],
            category: [],
            cards: [],
            count: 0,
            page: 1,
            is_load: true,
            is_load_under: false,
            is_page: true,
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        async fetchCategory() {
            await axios.get("/api/card/category/detail/" + this.$route.query.type)
                .then((response) => {
                    this.cards = response.data.cards.data
                    this.category = response.data.category
                    this.count = response.data.count

                    if (this.count <= 9) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カテゴリの取得に失敗しました");
                    }
                })
        },
        async fetchCategoryMore() {
            this.is_load_under = true
            this.page++

            await axios.get("/api/card/category/detail/" + this.$route.query.type + "?page=" + this.page)
                .then((response) => {
                    this.cards.push.apply(this.cards, response.data.cards.data)

                    if (response.data.cards.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カテゴリの取得に失敗しました");
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async fetchCategorys() {
            await axios.get("/api/card/category/list")
                .then((response) => {
                    this.categorys = response.data.categorys
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カテゴリの取得に失敗しました");
                    }
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)

            if (p < 1 && this.is_page) {
                this.fetchCategoryMore()
            }
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.fetchCategory()
                            this.fetchCategorys()
                        })
                    .catch((error) =>{
                        this.$showErrorToast("ユーザーの取得に失敗しました", false)
                    })
            }
            else {
                this.fetchCategory()
                this.fetchCategorys()
            }
        }
        else {
            this.fetchCategory()
            this.fetchCategorys()
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
};
</script>

<style scoped>
a {
    text-decoration: none;
    color: #000;
}

.category-box {
    padding: 20px 20px;
    background-color: #6b4eff;
    color: #fff;
    border-radius: 10px;
    font-size: 13px;
}

.category-box-filter {
    padding: 20px 20px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    border-radius: 10px;
    font-size: 13px;
}

.category-header {
    padding: 45px 10px;
    background-color: #6b4eff;
    color: #fff;
}

.category-header-filter {
    padding: 45px 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
}

.luna-footer-card-menu {
    position: fixed;
    bottom: 0;
    width: 538px;
    height: 80px;
    background-color: #fff;
    padding-top: 15px;
    z-index: 99999;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-card-menu {
        width: 100%;
    }
}</style>
